import type { ToggleButtonInputProps } from '@healthnz-prm/fhir-engine-renderer/types'
import { InputFieldset } from '../inputFieldset'
import { ToggleGroup, ToggleGroupItem } from '@/components/ui/toggle-group'

interface EnrichedToggleButtonInputProps extends ToggleButtonInputProps {
  handleChange(val: string): void
}

function BooleanInput({
  disabled,
  handleChange,
  options,
  value
}: EnrichedToggleButtonInputProps) {
  return (
    <ToggleGroup
      disabled={disabled}
      value={value ? `index-${options[value].value}` : ''}
      onValueChange={handleChange}
      type='single'
      size='lg'
      variant='outline'
    >
      <ToggleGroupItem value={`index-${options[0].value}`}>
        {options[0].label}
      </ToggleGroupItem>
      <ToggleGroupItem value={`index-${options[1].value}`}>
        {options[1].label}
      </ToggleGroupItem>
    </ToggleGroup>
  )
}

function ToggleInput(props: EnrichedToggleButtonInputProps) {
  const { options } = props

  switch (options.length) {
    case 0:
      return <p>No options provided</p>
    case 1:
      return <p>Not enough options provided</p>
    case 2:
      return <BooleanInput {...props} />
    default:
      return <p>Too many options provided</p>
  }
}

export default function ToggleButtonInput(props: ToggleButtonInputProps) {
  const { onChange } = props

  function handleChange(newValue: string) {
    if (!newValue.startsWith('index-')) return

    const parsedValue = Number.parseInt(newValue.slice(6), 10)

    onChange(parsedValue)
  }

  return (
    <InputFieldset {...props}>
      <ToggleInput {...props} handleChange={handleChange} />
    </InputFieldset>
  )
}
